import * as yup from 'yup';

const schema = () =>
  yup.object().shape({
    commentNotificationEnabled: yup.boolean().nullable(),
    sendEventEmails: yup.boolean().nullable(),
    sendForumDigest: yup.boolean().nullable(),
    sendPromotionEmails: yup.boolean().nullable(),
    sendProductEmails: yup.boolean().nullable(),
    surveyEnabled: yup.boolean().nullable(),
  });

export default schema;
